/* global mixpanel */
import _ from 'lodash'

export function translateInventoryCode (inventory) {
  switch (inventory) {
    case 1:
    case '1':
      return 'Low Stock Alert'
    case 2:
    case '2':
      return 'Out of Stock Alert'
    default:
      return 'All'
  }
}

export function libraryItemStart ({outletIds, category, inventory}) {
  mixpanel.track('Library Item Start', {
    'Current Selected Outlet': outletIds,
    'Current Category Filter': category || 'All',
    'Current Inventory Filter': translateInventoryCode(inventory)
  })
}

export function libraryItemChangeFilter ({outletIds, category, inventory}) {
  const mixpanelData = {
    'Current Selected Outlet': outletIds,
    'Current Category Filter': category || 'All',
    'Current Inventory Filter': translateInventoryCode(inventory)
  }
  mixpanel.track('Library Item Change Filter', mixpanelData)
}

export function libraryItemCreate ({item, allOutlet}) {
  const eventName = (allOutlet) ? 'Library Item Create All Outlet' : 'Library Item Create One Outlet'
  mixpanel.track(eventName, {
    'Name': item.name,
    'Category': item.category_id,
    'Variants': _.map(item.item_variants, 'id'),
    'Trackings': _.map(item.item_variants, 'track_stock'),
    'Modifiers': item.modifier_ids,
    'Taxes': _.map(item.taxes, 'id')
  })
}

export function libraryItemUpdate ({item}) {
  mixpanel.track('Library Item Update One Outlet', {
    'New Name': item.name,
    'New Category': item.category_id,
    'New Variants': _.map(item.item_variants, 'id'),
    'New Trackings': _.map(item.item_variants, 'track_stock'),
    'New Modifiers': item.modifier_ids,
    'New Taxes': _.map(item.taxes, 'id')
  })
}

/**
 * @param eventName 'modify' or 'replace'
 */
export function libraryItemImport ({eventName}) {
  mixpanel.track(`Library Item Import ${eventName}`)
}

export function libraryItemDelete ({item}) {
  mixpanel.track('Library Item Delete', {
    'Name': item.name,
    'Category': item.category_id,
    'Variants': _.map(item.item_variants, 'id'),
    'Trackings': _.map(item.item_variants, 'track_stock'),
    'Modifiers': _.map(item.active_modifiers, 'id')
  })
}

export function libraryItemExport () {
  mixpanel.track('Library Item Export')
}

export function cogsTrackingItem ({itemVariant, cogsTrack}) {
  const eventName = !cogsTrack ? 'COGS Tracking Start Item' : 'COGS Tracking Manage Item'
  mixpanel.track(eventName, {
    'Item Variant [List]': itemVariant,
    'Name': _.map(itemVariant, 'name'),
    'Average Cost': _.map(itemVariant, 'cogs')
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/library/list.js